import { useState } from 'react';
import LeadCard from '../LeadCard/LeadCard';
import './LeadKanbanColumn.css';

export default function LeadKanbanColumn({ column, leads, totalActive, onCardClick, onDrop }) {
  const [isDragOver, setIsDragOver] = useState(false);
  const pct = totalActive > 0 ? Math.round((leads.length / totalActive) * 100) : 0;

  function handleDragOver(e) {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  }

  function handleDragEnter(e) {
    e.preventDefault();
    setIsDragOver(true);
  }

  function handleDragLeave(e) {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsDragOver(false);
    }
  }

  function handleDrop(e) {
    e.preventDefault();
    setIsDragOver(false);
    const leadId = e.dataTransfer.getData('leadId');
    if (leadId) onDrop(leadId, column.status);
  }

  return (
    <div className="lkc__col">
      <div className="lkc__header" style={{ borderTopColor: column.color }}>
        <div className="lkc__header-top">
          <span className="lkc__label">{column.label}</span>
          <span className="lkc__count" style={{ background: column.color }}>{leads.length}</span>
        </div>
        <div className="lkc__funnel-track">
          <div className="lkc__funnel-fill" style={{ width: `${pct}%`, background: column.color }} />
        </div>
      </div>

      <div
        className={`lkc__cards ${isDragOver ? 'lkc__cards--drag-over' : ''}`}
        onDragOver={handleDragOver}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        {leads.length === 0 && (
          <div className="lkc__empty">{isDragOver ? 'Drop here' : 'No leads here'}</div>
        )}
        {leads.map(lead => (
          <LeadCard key={lead._id} lead={lead} onClick={onCardClick} />
        ))}
      </div>
    </div>
  );
}
